import { MENU_ITEMS } from '@/assets/data/menu-items'
import type { MenuItemType } from '@/common/types/menu'

export const getMenuItems = (): MenuItemType[] => {
  return MENU_ITEMS
}

export const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
  let parents: string[] = []
  const parent = findMenuItem(menuItems, menuItem.parentKey)
  if (parent) {
    parents.push(parent.key)
    if (parent.parentKey) {
      parents = [...parents, ...findAllParent(menuItems, parent)]
    }
  }
  return parents
}

const flattenMenuItems = (items: MenuItemType[]): MenuItemType[] =>
  items.flatMap((item) => [item, ...flattenMenuItems(item.children ?? [])])

/**
 * Resolve the sidebar entry to highlight for a URL. An exact match wins; a
 * child route such as `/brands/add` or `/brands/edit/7` falls back to the
 * deepest entry whose own URL is a path prefix of it, so the section a page
 * belongs to stays highlighted while you are inside it.
 */
export const getMenuItemFromURL = (items: MenuItemType | MenuItemType[], url: string): MenuItemType | undefined => {
  const candidates = flattenMenuItems(items instanceof Array ? items : [items])

  const exactMatch = candidates.find((item) => item.url === url)
  if (exactMatch) return exactMatch

  return candidates
    .filter((item) => item.url && url.startsWith(`${item.url}/`))
    .sort((a, b) => b.url!.length - a.url!.length)[0]
}

export const findMenuItem = (menuItems: MenuItemType[] | undefined, menuItemKey: MenuItemType['key'] | undefined): MenuItemType | null => {
  if (menuItems && menuItemKey) {
    for (const item of menuItems) {
      if (item.key === menuItemKey) {
        return item
      }
      const found = findMenuItem(item.children, menuItemKey)
      if (found) return found
    }
  }
  return null
}
